export default [
  {
    series: [
      {
        name: 'Nord Stream',
        className: 'color-historic',
        data: [
          [1641081600000, 148],
          [1641168000000, 149],
          [1641254400000, 147],
          [1641340800000, 147],
          [1641427200000, 149],
          [1641513600000, 148],
          [1641600000000, 149],
          [1641686400000, 147],
          [1641772800000, 146],
          [1641859200000, 146],
          [1641945600000, 147],
          [1642032000000, 147],
          [1642118400000, 146],
          [1642204800000, 146],
          [1642291200000, 147],
          [1642377600000, 146],
          [1642464000000, 149],
          [1642550400000, 147],
          [1642636800000, 146],
          [1642723200000, 147],
          [1642809600000, 147],
          [1642896000000, 146],
          [1642982400000, 147],
          [1643068800000, 146],
          [1643155200000, 149],
          [1643241600000, 149],
          [1643328000000, 149],
          [1643414400000, 149],
          [1643500800000, 149],
          [1643587200000, 149],
          [1643673600000, 149],
          [1643760000000, 158],
          [1643846400000, 158],
          [1643932800000, 159],
          [1644019200000, 158],
          [1644105600000, 158],
          [1644192000000, 158],
          [1644278400000, 158],
          [1644364800000, 158],
          [1644451200000, 158],
          [1644537600000, 154],
          [1644624000000, 154],
          [1644710400000, 154],
          [1644796800000, 154],
          [1644883200000, 155],
          [1644969600000, 158],
          [1645056000000, 148],
          [1645142400000, 148],
          [1645228800000, 153],
          [1645315200000, 148],
          [1645401600000, 148],
          [1645488000000, 148],
          [1645574400000, 153],
          [1645660800000, 159],
          [1645747200000, 158],
        ],
      },
      {
        name: 'Ukraine',
        className: 'color-teal',
        data: [
          [1641081600000, 62.3],
          [1641168000000, 49.8],
          [1641254400000, 41.3],
          [1641340800000, 37.5],
          [1641427200000, 38.8],
          [1641513600000, 36.1],
          [1641600000000, 38.3],
          [1641686400000, 35.9],
          [1641772800000, 35.6],
          [1641859200000, 40.7],
          [1641945600000, 36.3],
          [1642032000000, 48.8],
          [1642118400000, 45.4],
          [1642204800000, 39],
          [1642291200000, 37.1],
          [1642377600000, 36.1],
          [1642464000000, 37],
          [1642550400000, 34.4],
          [1642636800000, 33.1],
          [1642723200000, 33.2],
          [1642809600000, 39.5],
          [1642896000000, 33],
          [1642982400000, 31.6],
          [1643068800000, 48.4],
          [1643155200000, 50.9],
          [1643241600000, 70.8],
          [1643328000000, 65.5],
          [1643414400000, 54.6],
          [1643500800000, 50.7],
          [1643587200000, 50.1],
          [1643673600000, 56],
          [1643760000000, 87.2],
          [1643846400000, 71.3],
          [1643932800000, 62.8],
          [1644019200000, 62.9],
          [1644105600000, 69.1],
          [1644192000000, 71.7],
          [1644278400000, 77.4],
          [1644364800000, 65.5],
          [1644451200000, 59.7],
          [1644537600000, 40.4],
          [1644624000000, 37.4],
          [1644710400000, 37.2],
          [1644796800000, 37],
          [1644883200000, 46.4],
          [1644969600000, 54.5],
          [1645056000000, 37.2],
          [1645142400000, 34.4],
          [1645228800000, 33.8],
          [1645315200000, 31.7],
          [1645401600000, 32],
          [1645488000000, 39.9],
          [1645574400000, 45.9],
          [1645660800000, 54.7],
          [1645747200000, 74.8],
        ],
      },
      {
        name: 'Turkstream',
        className: 'color-blue',
        data: [
          [1641081600000, 22.5],
          [1641168000000, 24],
          [1641254400000, 25.2],
          [1641340800000, 26.3],
          [1641427200000, 26.3],
          [1641513600000, 26.2],
          [1641600000000, 26.9],
          [1641686400000, 25.8],
          [1641772800000, 25.7],
          [1641859200000, 32.3],
          [1641945600000, 31],
          [1642032000000, 34.6],
          [1642118400000, 32.6],
          [1642204800000, 36.9],
          [1642291200000, 35.5],
          [1642377600000, 34.6],
          [1642464000000, 39.1],
          [1642550400000, 36.1],
          [1642636800000, 37.6],
          [1642723200000, 36.6],
          [1642809600000, 35.9],
          [1642896000000, 35.1],
          [1642982400000, 33.7],
          [1643068800000, 38.6],
          [1643155200000, 38.3],
          [1643241600000, 38.4],
          [1643328000000, 37.9],
          [1643414400000, 37.9],
          [1643500800000, 36.5],
          [1643587200000, 34.4],
          [1643673600000, 34.1],
          [1643760000000, 41.5],
          [1643846400000, 37.7],
          [1643932800000, 38.1],
          [1644019200000, 38.1],
          [1644105600000, 38],
          [1644192000000, 37.6],
          [1644278400000, 37],
          [1644364800000, 37.7],
          [1644451200000, 37.1],
          [1644537600000, 37.3],
          [1644624000000, 35.6],
          [1644710400000, 35.2],
          [1644796800000, 35.4],
          [1644883200000, 38.1],
          [1644969600000, 38.1],
          [1645056000000, 39.5],
          [1645142400000, 38.3],
          [1645228800000, 35.1],
          [1645315200000, 33.8],
          [1645401600000, 34.1],
          [1645488000000, 34.6],
          [1645574400000, 35.1],
          [1645660800000, 36.5],
          [1645747200000, 42],
        ],
      },
      {
        name: 'Poland',
        className: 'color-green',
        data: [
          [1641081600000, 14.4],
          [1641168000000, 9.52],
          [1641254400000, 8.79],
          [1641340800000, 5.03],
          [1641427200000, 20.6],
          [1641513600000, 5.11],
          [1641600000000, 5.09],
          [1641686400000, 4.65],
          [1641772800000, 4.65],
          [1641859200000, 4.73],
          [1641945600000, 4.73],
          [1642032000000, 4.74],
          [1642118400000, 4.68],
          [1642204800000, 4.66],
          [1642291200000, 4.63],
          [1642377600000, 4.64],
          [1642464000000, 4.69],
          [1642550400000, 4.67],
          [1642636800000, 4.7],
          [1642723200000, 4.69],
          [1642809600000, 4.68],
          [1642896000000, 4.65],
          [1642982400000, 4.7],
          [1643068800000, 4.7],
          [1643155200000, 4.64],
          [1643241600000, 4.65],
          [1643328000000, 4.65],
          [1643414400000, 4.63],
          [1643500800000, 4.59],
          [1643587200000, 4.62],
          [1643673600000, 8.29],
          [1643760000000, 24],
          [1643846400000, 24.4],
          [1643932800000, 21.4],
          [1644019200000, 21.6],
          [1644105600000, 22.2],
          [1644192000000, 22.2],
          [1644278400000, 22.4],
          [1644364800000, 14.7],
          [1644451200000, 23.2],
          [1644537600000, 20.7],
          [1644624000000, 21.8],
          [1644710400000, 21.3],
          [1644796800000, 21.3],
          [1644883200000, 21.4],
          [1644969600000, 21.4],
          [1645056000000, 21.2],
          [1645142400000, 20],
          [1645228800000, 21.3],
          [1645315200000, 21.4],
          [1645401600000, 21.3],
          [1645488000000, 21.4],
          [1645574400000, 21.4],
          [1645660800000, 21.4],
          [1645747200000, 21.6],
        ],
      },
      {
        name: 'Other',
        className: 'color-yellow',
        data: [
          [1641081600000, 1.09],
          [1641168000000, 2.01],
          [1641254400000, 1.98],
          [1641340800000, 1.8],
          [1641427200000, 3.07],
          [1641513600000, 3.14],
          [1641600000000, 3.21],
          [1641686400000, 1.84],
          [1641772800000, 4.92],
          [1641859200000, 4.73],
          [1641945600000, 2.77],
          [1642032000000, 1.72],
          [1642118400000, 1.9],
          [1642204800000, 1.07],
          [1642291200000, 1.16],
          [1642377600000, 1.63],
          [1642464000000, 2.07],
          [1642550400000, 0.934],
          [1642636800000, 1.53],
          [1642723200000, 2.26],
          [1642809600000, 2.24],
          [1642896000000, 0.184],
          [1642982400000, 1.41],
          [1643068800000, 2.3],
          [1643155200000, 4.08],
          [1643241600000, 2.35],
          [1643328000000, 2.96],
          [1643414400000, 2.14],
          [1643500800000, 1.97],
          [1643587200000, 3.31],
          [1643673600000, 4.57],
          [1643760000000, 5.08],
          [1643846400000, 6.1],
          [1643932800000, 3.6],
          [1644019200000, 2],
          [1644105600000, 1.13],
          [1644192000000, 1.36],
          [1644278400000, 3.4],
          [1644364800000, 4.32],
          [1644451200000, 3.97],
          [1644537600000, 3.76],
          [1644624000000, 2.66],
          [1644710400000, 2.8],
          [1644796800000, 2.08],
          [1644883200000, 3.28],
          [1644969600000, 3.51],
          [1645056000000, 4.25],
          [1645142400000, 2.63],
          [1645228800000, 1.19],
          [1645315200000, 1.66],
          [1645401600000, 3.91],
          [1645488000000, 1.72],
          [1645574400000, 2.51],
          [1645660800000, 3.9],
          [1645747200000, 11.3],
        ],
      },
    ],
  },
  {
    series: [
      {
        name: 'Nord Stream',
        className: 'color-historic',
        data: [
          [1641081600000, 148],
          [1641168000000, 149],
          [1641254400000, 147],
          [1641340800000, 147],
          [1641427200000, 149],
          [1641513600000, 148],
          [1641600000000, 149],
          [1641686400000, 147],
          [1641772800000, 146],
          [1641859200000, 146],
          [1641945600000, 147],
          [1642032000000, 147],
          [1642118400000, 146],
          [1642204800000, 146],
          [1642291200000, 147],
          [1642377600000, 146],
          [1642464000000, 149],
          [1642550400000, 147],
          [1642636800000, 146],
          [1642723200000, 147],
          [1642809600000, 147],
          [1642896000000, 146],
          [1642982400000, 147],
          [1643068800000, 146],
          [1643155200000, 149],
          [1643241600000, 149],
          [1643328000000, 149],
          [1643414400000, 149],
          [1643500800000, 149],
          [1643587200000, 149],
          [1643673600000, 149],
          [1643760000000, 158],
          [1643846400000, 158],
          [1643932800000, 159],
          [1644019200000, 158],
          [1644105600000, 158],
          [1644192000000, 158],
          [1644278400000, 158],
          [1644364800000, 158],
          [1644451200000, 158],
          [1644537600000, 154],
          [1644624000000, 154],
          [1644710400000, 154],
          [1644796800000, 154],
          [1644883200000, 155],
          [1644969600000, 158],
          [1645056000000, 148],
          [1645142400000, 148],
          [1645228800000, 153],
          [1645315200000, 148],
          [1645401600000, 148],
          [1645488000000, 148],
          [1645574400000, 153],
          [1645660800000, 159],
          [1645747200000, 158],
          [1645833600000, 158],
          [1645920000000, 159],
          [1646006400000, 158],
          [1646092800000, 158],
          [1646179200000, 157],
          [1646265600000, 158],
          [1646352000000, 153],
          [1646438400000, 162],
          [1646524800000, 159],
          [1646611200000, 158],
          [1646697600000, 158],
          [1646784000000, 158],
          [1646870400000, 158],
          [1646956800000, 158],
          [1647043200000, 158],
          [1647129600000, 158],
          [1647216000000, 158],
          [1647302400000, 158],
          [1647388800000, 158],
          [1647475200000, 146],
          [1647561600000, 135],
          [1647648000000, 124],
          [1647734400000, 124],
          [1647820800000, 124],
          [1647907200000, 131],
          [1647993600000, 142],
          [1648080000000, 141],
          [1648166400000, 151],
          [1648252800000, 158],
          [1648339200000, 151],
          [1648425600000, 158],
          [1648512000000, 158],
          [1648598400000, 158],
          [1648684800000, 158],
          [1648771200000, 158],
          [1648857600000, 158],
          [1648944000000, 159],
          [1649030400000, 158],
          [1649116800000, 158],
          [1649203200000, 159],
          [1649289600000, 158],
          [1649376000000, 158],
          [1649462400000, 158],
          [1649548800000, 158],
          [1649635200000, 158],
          [1649721600000, 159],
          [1649808000000, 158],
          [1649894400000, 158],
          [1649980800000, 158],
          [1650067200000, 158],
          [1650153600000, 158],
          [1650240000000, 158],
          [1650326400000, 158],
          [1650412800000, 158],
          [1650499200000, 158],
          [1650585600000, 158],
          [1650672000000, 158],
          [1650758400000, 157],
          [1650844800000, 158],
          [1650931200000, 159],
          [1651017600000, 158],
          [1651104000000, 156],
          [1651190400000, 156],
          [1651276800000, 156],
          [1651363200000, 156],
          [1651449600000, 156],
          [1651536000000, 158],
          [1651622400000, 158],
          [1651708800000, 158],
          [1651795200000, 158],
          [1651881600000, 158],
          [1651968000000, 158],
          [1652054400000, 158],
          [1652140800000, 158],
          [1652227200000, 158],
          [1652313600000, 158],
          [1652400000000, 158],
          [1652486400000, 158],
          [1652572800000, 158],
          [1652659200000, 158],
          [1652745600000, 158],
          [1652832000000, 158],
          [1652918400000, 158],
          [1653004800000, 158],
          [1653091200000, 158],
          [1653177600000, 158],
          [1653264000000, 158],
          [1653350400000, 158],
          [1653436800000, 158],
          [1653523200000, 158],
          [1653609600000, 158],
          [1653696000000, 155],
          [1653782400000, 158],
          [1653868800000, 158],
          [1653955200000, 158],
          [1654041600000, 142],
          [1654128000000, 158],
          [1654214400000, 157],
          [1654300800000, 155],
          [1654387200000, 144],
          [1654473600000, 144],
          [1654560000000, 146],
          [1654646400000, 142],
          [1654732800000, 140],
          [1654819200000, 134],
          [1654905600000, 136],
          [1654992000000, 132],
          [1655078400000, 135],
          [1655164800000, 108],
          [1655251200000, 94.4],
          [1655337600000, 88.8],
          [1655424000000, 64.7],
          [1655510400000, 63.2],
          [1655596800000, 63],
          [1655683200000, 63.2],
          [1655769600000, 63.2],
          [1655856000000, 63.3],
          [1655942400000, 63.2],
          [1656028800000, 63.2],
          [1656115200000, 63.3],
          [1656201600000, 63.2],
          [1656288000000, 63.2],
          [1656374400000, 63.3],
          [1656460800000, 63.2],
          [1656547200000, 63.3],
          [1656633600000, 63.2],
          [1656720000000, 63.3],
          [1656806400000, 63.2],
          [1656892800000, 63.2],
          [1656979200000, 63.7],
          [1657065600000, 62.7],
          [1657152000000, 63.4],
          [1657238400000, 63.2],
          [1657324800000, 63.3],
          [1657411200000, 63.7],
          [1657497600000, 62.8],
          [1657584000000, 5.41],
          [1657670400000, 0],
          [1657756800000, 0],
          [1657843200000, 0],
          [1657929600000, 0],
          [1658016000000, 0],
          [1658102400000, 0],
          [1658188800000, 0],
          [1658275200000, 0],
          [1658361600000, 0],
          [1658448000000, 62.5],
          [1658534400000, 63.2],
          [1658620800000, 62.7],
          [1658707200000, 63],
          [1658793600000, 63.2],
          [1658880000000, 60.2],
          [1658966400000, 33.6],
          [1659052800000, 31.2],
          [1659139200000, 31.1],
          [1659225600000, 31.1],
          [1659312000000, 28.6],
          [1659398400000, 30.1],
          [1659484800000, 31.2],
          [1659571200000, 31.2],
          [1659657600000, 31.2],
          [1659744000000, 31.2],
          [1659830400000, 31.2],
          [1659916800000, 31.2],
          [1660003200000, 31.2],
          [1660089600000, 31.2],
          [1660176000000, 31.1],
          [1660262400000, 31.3],
          [1660348800000, 31.3],
          [1660435200000, 31.6],
          [1660521600000, 31.4],
          [1660608000000, 31.5],
          [1660694400000, 31.5],
          [1660780800000, 31.2],
          [1660867200000, 31.2],
          [1660953600000, 31.2],
          [1661040000000, 31.2],
          [1661126400000, 31.2],
          [1661212800000, 31.2],
          [1661299200000, 31.2],
          [1661385600000, 31.3],
          [1661472000000, 31.3],
          [1661558400000, 31.2],
          [1661644800000, 31.2],
          [1661731200000, 31.2],
          [1661817600000, 31.3],
          [1661904000000, 26.2],
          [1661990400000, 0.0209],
          [1662076800000, 0],
          [1662163200000, 0],
          [1662249600000, 0],
          [1662336000000, 0],
          [1662422400000, 0],
          [1662508800000, 0],
          [1662595200000, 0],
          [1662681600000, 0],
          [1662768000000, 0],
          [1662854400000, 0],
          [1662940800000, 0],
          [1663027200000, 0],
          [1663113600000, 0],
          [1663200000000, 0],
          [1663286400000, 0],
          [1663372800000, 0],
          [1663459200000, 0],
          [1663545600000, 0],
          [1663632000000, 0],
          [1663718400000, 0],
          [1663804800000, 0],
          [1663891200000, 0],
          [1663977600000, 0],
          [1664064000000, 0],
          [1664150400000, 0],
          [1664236800000, 0],
          [1664323200000, 0],
          [1664409600000, 0],
          [1664496000000, 0],
          [1664582400000, 0],
          [1664668800000, 0],
          [1664755200000, 0],
          [1664841600000, 0],
          [1664928000000, 0],
          [1665014400000, 0],
          [1665100800000, 0],
          [1665187200000, 0],
          [1665273600000, 0],
          [1665360000000, 0],
        ],
      },
      {
        name: 'Ukraine',
        className: 'color-teal',
        animation: {
          defer: 0.25,
        },
        data: [
          [1641081600000, 62.3],
          [1641168000000, 49.8],
          [1641254400000, 41.3],
          [1641340800000, 37.5],
          [1641427200000, 38.8],
          [1641513600000, 36.1],
          [1641600000000, 38.3],
          [1641686400000, 35.9],
          [1641772800000, 35.6],
          [1641859200000, 40.7],
          [1641945600000, 36.3],
          [1642032000000, 48.8],
          [1642118400000, 45.4],
          [1642204800000, 39],
          [1642291200000, 37.1],
          [1642377600000, 36.1],
          [1642464000000, 37],
          [1642550400000, 34.4],
          [1642636800000, 33.1],
          [1642723200000, 33.2],
          [1642809600000, 39.5],
          [1642896000000, 33],
          [1642982400000, 31.6],
          [1643068800000, 48.4],
          [1643155200000, 50.9],
          [1643241600000, 70.8],
          [1643328000000, 65.5],
          [1643414400000, 54.6],
          [1643500800000, 50.7],
          [1643587200000, 50.1],
          [1643673600000, 56],
          [1643760000000, 87.2],
          [1643846400000, 71.3],
          [1643932800000, 62.8],
          [1644019200000, 62.9],
          [1644105600000, 69.1],
          [1644192000000, 71.7],
          [1644278400000, 77.4],
          [1644364800000, 65.5],
          [1644451200000, 59.7],
          [1644537600000, 40.4],
          [1644624000000, 37.4],
          [1644710400000, 37.2],
          [1644796800000, 37],
          [1644883200000, 46.4],
          [1644969600000, 54.5],
          [1645056000000, 37.2],
          [1645142400000, 34.4],
          [1645228800000, 33.8],
          [1645315200000, 31.7],
          [1645401600000, 32],
          [1645488000000, 39.9],
          [1645574400000, 45.9],
          [1645660800000, 54.7],
          [1645747200000, 74.8],
          [1645833600000, 91.1],
          [1645920000000, 90.1],
          [1646006400000, 90.6],
          [1646092800000, 90.4],
          [1646179200000, 91.6],
          [1646265600000, 91.4],
          [1646352000000, 91.6],
          [1646438400000, 91.4],
          [1646524800000, 92.4],
          [1646611200000, 91.7],
          [1646697600000, 92],
          [1646784000000, 91.7],
          [1646870400000, 92.2],
          [1646956800000, 92],
          [1647043200000, 92],
          [1647129600000, 91.5],
          [1647216000000, 91.7],
          [1647302400000, 91.9],
          [1647388800000, 86.6],
          [1647475200000, 78.1],
          [1647561600000, 77.3],
          [1647648000000, 88.9],
          [1647734400000, 88.4],
          [1647820800000, 88.3],
          [1647907200000, 90.4],
          [1647993600000, 91.3],
          [1648080000000, 88.5],
          [1648166400000, 86.7],
          [1648252800000, 86.9],
          [1648339200000, 91.2],
          [1648425600000, 91.4],
          [1648512000000, 91.6],
          [1648598400000, 91.3],
          [1648684800000, 91],
          [1648771200000, 91.5],
          [1648857600000, 96],
          [1648944000000, 97.2],
          [1649030400000, 97.1],
          [1649116800000, 96.9],
          [1649203200000, 96.9],
          [1649289600000, 97],
          [1649376000000, 93.9],
          [1649462400000, 80.4],
          [1649548800000, 69.3],
          [1649635200000, 70.4],
          [1649721600000, 83.9],
          [1649808000000, 64.2],
          [1649894400000, 56.1],
          [1649980800000, 70.4],
          [1650067200000, 60],
          [1650153600000, 47.5],
          [1650240000000, 47.4],
          [1650326400000, 47.4],
          [1650412800000, 45.9],
          [1650499200000, 46.8],
          [1650585600000, 47.7],
          [1650672000000, 49.2],
          [1650758400000, 40],
          [1650844800000, 43.8],
          [1650931200000, 58.8],
          [1651017600000, 46.4],
          [1651104000000, 55],
          [1651190400000, 53.9],
          [1651276800000, 54.8],
          [1651363200000, 59.8],
          [1651449600000, 83.7],
          [1651536000000, 89.4],
          [1651622400000, 89.6],
          [1651708800000, 89.4],
          [1651795200000, 89.6],
          [1651881600000, 89.8],
          [1651968000000, 79.8],
          [1652054400000, 89.1],
          [1652140800000, 90],
          [1652227200000, 79.6],
          [1652313600000, 66],
          [1652400000000, 56.3],
          [1652486400000, 54.5],
          [1652572800000, 58.3],
          [1652659200000, 58.2],
          [1652745600000, 50.2],
          [1652832000000, 43.5],
          [1652918400000, 47.9],
          [1653004800000, 56.6],
          [1653091200000, 56.1],
          [1653177600000, 38.8],
          [1653264000000, 37.8],
          [1653350400000, 37.6],
          [1653436800000, 39.6],
          [1653523200000, 38.2],
          [1653609600000, 37.9],
          [1653696000000, 40.2],
          [1653782400000, 37.5],
          [1653868800000, 37.7],
          [1653955200000, 39.2],
          [1654041600000, 36.2],
          [1654128000000, 35.4],
          [1654214400000, 35.5],
          [1654300800000, 35.5],
          [1654387200000, 35.5],
          [1654473600000, 35.6],
          [1654560000000, 35.6],
          [1654646400000, 35.6],
          [1654732800000, 35.6],
          [1654819200000, 19.3],
          [1654905600000, 34.1],
          [1654992000000, 34.2],
          [1655078400000, 34.3],
          [1655164800000, 34],
          [1655251200000, 34.4],
          [1655337600000, 34.2],
          [1655424000000, 34.2],
          [1655510400000, 34.4],
          [1655596800000, 34.3],
          [1655683200000, 34.4],
          [1655769600000, 33.8],
          [1655856000000, 34],
          [1655942400000, 34],
          [1656028800000, 34],
          [1656115200000, 34],
          [1656201600000, 34.1],
          [1656288000000, 34.1],
          [1656374400000, 34.2],
          [1656460800000, 33.8],
          [1656547200000, 34.3],
          [1656633600000, 34.5],
          [1656720000000, 35.7],
          [1656806400000, 35.6],
          [1656892800000, 35.4],
          [1656979200000, 35.5],
          [1657065600000, 35.5],
          [1657152000000, 35.6],
          [1657238400000, 35.5],
          [1657324800000, 35.7],
          [1657411200000, 35.5],
          [1657497600000, 35.6],
          [1657584000000, 35.8],
          [1657670400000, 35.7],
          [1657756800000, 35.2],
          [1657843200000, 35.6],
          [1657929600000, 35.2],
          [1658016000000, 35.8],
          [1658102400000, 35.2],
          [1658188800000, 35.3],
          [1658275200000, 35.5],
          [1658361600000, 35.6],
          [1658448000000, 35.5],
          [1658534400000, 35.2],
          [1658620800000, 35.7],
          [1658707200000, 35.5],
          [1658793600000, 35.3],
          [1658880000000, 35],
          [1658966400000, 35.4],
          [1659052800000, 35.3],
          [1659139200000, 35.1],
          [1659225600000, 35.4],
          [1659312000000, 35.3],
          [1659398400000, 34.8],
          [1659484800000, 34.4],
          [1659571200000, 34.7],
          [1659657600000, 34.7],
          [1659744000000, 34.4],
          [1659830400000, 34.1],
          [1659916800000, 34.4],
          [1660003200000, 34.2],
          [1660089600000, 34.4],
          [1660176000000, 35.2],
          [1660262400000, 34.2],
          [1660348800000, 34.2],
          [1660435200000, 33.9],
          [1660521600000, 34],
          [1660608000000, 34],
          [1660694400000, 34.2],
          [1660780800000, 35],
          [1660867200000, 34.8],
          [1660953600000, 35],
          [1661040000000, 34.9],
          [1661126400000, 34.7],
          [1661212800000, 35],
          [1661299200000, 35.2],
          [1661385600000, 35.2],
          [1661472000000, 35.3],
          [1661558400000, 35.1],
          [1661644800000, 35.2],
          [1661731200000, 35.2],
          [1661817600000, 35.6],
          [1661904000000, 35.9],
          [1661990400000, 35.6],
          [1662076800000, 36.2],
          [1662163200000, 35.7],
          [1662249600000, 35.6],
          [1662336000000, 35.2],
          [1662422400000, 35.8],
          [1662508800000, 35.1],
          [1662595200000, 35.9],
          [1662681600000, 35.8],
          [1662768000000, 35.5],
          [1662854400000, 35.4],
          [1662940800000, 35.6],
          [1663027200000, 35.6],
          [1663113600000, 35.8],
          [1663200000000, 35.2],
          [1663286400000, 35.5],
          [1663372800000, 35.5],
          [1663459200000, 35.4],
          [1663545600000, 35.3],
          [1663632000000, 35.4],
          [1663718400000, 35.6],
          [1663804800000, 35.2],
          [1663891200000, 35.2],
          [1663977600000, 35.7],
          [1664064000000, 35.7],
          [1664150400000, 35.8],
          [1664236800000, 35.4],
          [1664323200000, 35.7],
          [1664409600000, 35.7],
          [1664496000000, 35.7],
          [1664582400000, 35.7],
          [1664668800000, 35],
          [1664755200000, 35],
          [1664841600000, 35.1],
          [1664928000000, 34.5],
          [1665014400000, 35.6],
          [1665100800000, 35.6],
          [1665187200000, 35.6],
          [1665273600000, 35.4],
          [1665360000000, 35.5],
        ],
      },
      {
        name: 'Turkstream',
        className: 'color-blue',
        animation: {
          defer: 0.5,
        },
        data: [
          [1641081600000, 22.5],
          [1641168000000, 24],
          [1641254400000, 25.2],
          [1641340800000, 26.3],
          [1641427200000, 26.3],
          [1641513600000, 26.2],
          [1641600000000, 26.9],
          [1641686400000, 25.8],
          [1641772800000, 25.7],
          [1641859200000, 32.3],
          [1641945600000, 31],
          [1642032000000, 34.6],
          [1642118400000, 32.6],
          [1642204800000, 36.9],
          [1642291200000, 35.5],
          [1642377600000, 34.6],
          [1642464000000, 39.1],
          [1642550400000, 36.1],
          [1642636800000, 37.6],
          [1642723200000, 36.6],
          [1642809600000, 35.9],
          [1642896000000, 35.1],
          [1642982400000, 33.7],
          [1643068800000, 38.6],
          [1643155200000, 38.3],
          [1643241600000, 38.4],
          [1643328000000, 37.9],
          [1643414400000, 37.9],
          [1643500800000, 36.5],
          [1643587200000, 34.4],
          [1643673600000, 34.1],
          [1643760000000, 41.5],
          [1643846400000, 37.7],
          [1643932800000, 38.1],
          [1644019200000, 38.1],
          [1644105600000, 38],
          [1644192000000, 37.6],
          [1644278400000, 37],
          [1644364800000, 37.7],
          [1644451200000, 37.1],
          [1644537600000, 37.3],
          [1644624000000, 35.6],
          [1644710400000, 35.2],
          [1644796800000, 35.4],
          [1644883200000, 38.1],
          [1644969600000, 38.1],
          [1645056000000, 39.5],
          [1645142400000, 38.3],
          [1645228800000, 35.1],
          [1645315200000, 33.8],
          [1645401600000, 34.1],
          [1645488000000, 34.6],
          [1645574400000, 35.1],
          [1645660800000, 36.5],
          [1645747200000, 42],
          [1645833600000, 44],
          [1645920000000, 45.5],
          [1646006400000, 44.3],
          [1646092800000, 46.5],
          [1646179200000, 46.9],
          [1646265600000, 38.5],
          [1646352000000, 38.4],
          [1646438400000, 38.1],
          [1646524800000, 38.1],
          [1646611200000, 38.4],
          [1646697600000, 38.6],
          [1646784000000, 38.6],
          [1646870400000, 39],
          [1646956800000, 38.9],
          [1647043200000, 39.2],
          [1647129600000, 38.7],
          [1647216000000, 38.5],
          [1647302400000, 38.4],
          [1647388800000, 38.3],
          [1647475200000, 37.9],
          [1647561600000, 37.7],
          [1647648000000, 38.3],
          [1647734400000, 37.7],
          [1647820800000, 37.8],
          [1647907200000, 38.1],
          [1647993600000, 38.2],
          [1648080000000, 38.2],
          [1648166400000, 37.7],
          [1648252800000, 37.1],
          [1648339200000, 34.9],
          [1648425600000, 32.5],
          [1648512000000, 36.2],
          [1648598400000, 37.2],
          [1648684800000, 37],
          [1648771200000, 36.2],
          [1648857600000, 30.5],
          [1648944000000, 29.6],
          [1649030400000, 31.7],
          [1649116800000, 35.3],
          [1649203200000, 34.9],
          [1649289600000, 31.1],
          [1649376000000, 29],
          [1649462400000, 28.1],
          [1649548800000, 26.8],
          [1649635200000, 26.7],
          [1649721600000, 34.2],
          [1649808000000, 34],
          [1649894400000, 33.6],
          [1649980800000, 29.5],
          [1650067200000, 28.2],
          [1650153600000, 26.1],
          [1650240000000, 26.9],
          [1650326400000, 28.7],
          [1650412800000, 29.3],
          [1650499200000, 30.8],
          [1650585600000, 30.3],
          [1650672000000, 26.9],
          [1650758400000, 26.8],
          [1650844800000, 25.7],
          [1650931200000, 26.7],
          [1651017600000, 28.1],
          [1651104000000, 21],
          [1651190400000, 22.4],
          [1651276800000, 21.2],
          [1651363200000, 21],
          [1651449600000, 28.1],
          [1651536000000, 29.6],
          [1651622400000, 28.3],
          [1651708800000, 31.5],
          [1651795200000, 35.3],
          [1651881600000, 34.7],
          [1651968000000, 33.9],
          [1652054400000, 33.7],
          [1652140800000, 33],
          [1652227200000, 31],
          [1652313600000, 28.1],
          [1652400000000, 25.8],
          [1652486400000, 31.6],
          [1652572800000, 31.9],
          [1652659200000, 30.9],
          [1652745600000, 28.5],
          [1652832000000, 27.2],
          [1652918400000, 26.5],
          [1653004800000, 23.4],
          [1653091200000, 19.7],
          [1653177600000, 20.1],
          [1653264000000, 19.8],
          [1653350400000, 21.7],
          [1653436800000, 20.8],
          [1653523200000, 21.5],
          [1653609600000, 22.1],
          [1653696000000, 20.9],
          [1653782400000, 20.3],
          [1653868800000, 19.6],
          [1653955200000, 21],
          [1654041600000, 21.5],
          [1654128000000, 19.8],
          [1654214400000, 20.4],
          [1654300800000, 18],
          [1654387200000, 22.3],
          [1654473600000, 23.9],
          [1654560000000, 22.2],
          [1654646400000, 20.4],
          [1654732800000, 20.6],
          [1654819200000, 22.1],
          [1654905600000, 22.1],
          [1654992000000, 22.2],
          [1655078400000, 20.6],
          [1655164800000, 20.8],
          [1655251200000, 21.2],
          [1655337600000, 24.5],
          [1655424000000, 27],
          [1655510400000, 29.4],
          [1655596800000, 28],
          [1655683200000, 29.8],
          [1655769600000, 31.9],
          [1655856000000, 0.0000182],
          [1655942400000, 0.0000367],
          [1656028800000, 0.0000367],
          [1656115200000, 0],
          [1656201600000, 0],
          [1656288000000, 0],
          [1656374400000, 14.3],
          [1656460800000, 31.7],
          [1656547200000, 32.7],
          [1656633600000, 34.1],
          [1656720000000, 34.2],
          [1656806400000, 32.9],
          [1656892800000, 32.6],
          [1656979200000, 33.3],
          [1657065600000, 34.3],
          [1657152000000, 33.9],
          [1657238400000, 33.9],
          [1657324800000, 33.9],
          [1657411200000, 33.9],
          [1657497600000, 33.7],
          [1657584000000, 38.8],
          [1657670400000, 42.2],
          [1657756800000, 42.8],
          [1657843200000, 43.4],
          [1657929600000, 42.8],
          [1658016000000, 42.5],
          [1658102400000, 41.7],
          [1658188800000, 42.9],
          [1658275200000, 42.7],
          [1658361600000, 42.7],
          [1658448000000, 42.8],
          [1658534400000, 43.7],
          [1658620800000, 42.5],
          [1658707200000, 41.9],
          [1658793600000, 42],
          [1658880000000, 43],
          [1658966400000, 42.9],
          [1659052800000, 42.7],
          [1659139200000, 43.1],
          [1659225600000, 42.3],
          [1659312000000, 41.7],
          [1659398400000, 38.3],
          [1659484800000, 40.2],
          [1659571200000, 39.5],
          [1659657600000, 36.9],
          [1659744000000, 39.2],
          [1659830400000, 37.7],
          [1659916800000, 36.4],
          [1660003200000, 33.4],
          [1660089600000, 34.3],
          [1660176000000, 33.9],
          [1660262400000, 39.9],
          [1660348800000, 44.3],
          [1660435200000, 43.9],
          [1660521600000, 42],
          [1660608000000, 41.7],
          [1660694400000, 43.3],
          [1660780800000, 40.4],
          [1660867200000, 41.2],
          [1660953600000, 41.5],
          [1661040000000, 42.4],
          [1661126400000, 42.1],
          [1661212800000, 42.3],
          [1661299200000, 41],
          [1661385600000, 41.1],
          [1661472000000, 41.1],
          [1661558400000, 40.5],
          [1661644800000, 42.7],
          [1661731200000, 44.8],
          [1661817600000, 41.4],
          [1661904000000, 41.9],
          [1661990400000, 36.6],
          [1662076800000, 41.8],
          [1662163200000, 41.3],
          [1662249600000, 39.2],
          [1662336000000, 37],
          [1662422400000, 31.3],
          [1662508800000, 37.3],
          [1662595200000, 38.5],
          [1662681600000, 37.3],
          [1662768000000, 38.3],
          [1662854400000, 38.1],
          [1662940800000, 39.2],
          [1663027200000, 39.6],
          [1663113600000, 40.2],
          [1663200000000, 42.5],
          [1663286400000, 41.8],
          [1663372800000, 40.6],
          [1663459200000, 33.4],
          [1663545600000, 33.5],
          [1663632000000, 34.2],
          [1663718400000, 37.8],
          [1663804800000, 36.8],
          [1663891200000, 37.1],
          [1663977600000, 35.5],
          [1664064000000, 32.5],
          [1664150400000, 30.3],
          [1664236800000, 32.6],
          [1664323200000, 31],
          [1664409600000, 30.8],
          [1664496000000, 30.4],
          [1664582400000, 28.9],
          [1664668800000, 26],
          [1664755200000, 25],
          [1664841600000, 28.6],
          [1664928000000, 31.7],
          [1665014400000, 27],
          [1665100800000, 28],
          [1665187200000, 28.1],
          [1665273600000, 27.3],
          [1665360000000, 27.9],
        ],
      },
      {
        name: 'Poland',
        className: 'color-green',
        animation: {
          defer: 0.75,
        },
        data: [
          [1641081600000, 14.4],
          [1641168000000, 9.52],
          [1641254400000, 8.79],
          [1641340800000, 5.03],
          [1641427200000, 20.6],
          [1641513600000, 5.11],
          [1641600000000, 5.09],
          [1641686400000, 4.65],
          [1641772800000, 4.65],
          [1641859200000, 4.73],
          [1641945600000, 4.73],
          [1642032000000, 4.74],
          [1642118400000, 4.68],
          [1642204800000, 4.66],
          [1642291200000, 4.63],
          [1642377600000, 4.64],
          [1642464000000, 4.69],
          [1642550400000, 4.67],
          [1642636800000, 4.7],
          [1642723200000, 4.69],
          [1642809600000, 4.68],
          [1642896000000, 4.65],
          [1642982400000, 4.7],
          [1643068800000, 4.7],
          [1643155200000, 4.64],
          [1643241600000, 4.65],
          [1643328000000, 4.65],
          [1643414400000, 4.63],
          [1643500800000, 4.59],
          [1643587200000, 4.62],
          [1643673600000, 8.29],
          [1643760000000, 24],
          [1643846400000, 24.4],
          [1643932800000, 21.4],
          [1644019200000, 21.6],
          [1644105600000, 22.2],
          [1644192000000, 22.2],
          [1644278400000, 22.4],
          [1644364800000, 14.7],
          [1644451200000, 23.2],
          [1644537600000, 20.7],
          [1644624000000, 21.8],
          [1644710400000, 21.3],
          [1644796800000, 21.3],
          [1644883200000, 21.4],
          [1644969600000, 21.4],
          [1645056000000, 21.2],
          [1645142400000, 20],
          [1645228800000, 21.3],
          [1645315200000, 21.4],
          [1645401600000, 21.3],
          [1645488000000, 21.4],
          [1645574400000, 21.4],
          [1645660800000, 21.4],
          [1645747200000, 21.6],
          [1645833600000, 24.7],
          [1645920000000, 37],
          [1646006400000, 28.5],
          [1646092800000, 28.7],
          [1646179200000, 44.2],
          [1646265600000, 45.2],
          [1646352000000, 48.9],
          [1646438400000, 45.9],
          [1646524800000, 48.1],
          [1646611200000, 46.3],
          [1646697600000, 46.8],
          [1646784000000, 47],
          [1646870400000, 46.5],
          [1646956800000, 47.7],
          [1647043200000, 49.6],
          [1647129600000, 48.5],
          [1647216000000, 48.1],
          [1647302400000, 47.7],
          [1647388800000, 25],
          [1647475200000, 21.3],
          [1647561600000, 20.6],
          [1647648000000, 21],
          [1647734400000, 21.1],
          [1647820800000, 21.4],
          [1647907200000, 21.1],
          [1647993600000, 22],
          [1648080000000, 21.9],
          [1648166400000, 21.7],
          [1648252800000, 21.3],
          [1648339200000, 20.6],
          [1648425600000, 21.3],
          [1648512000000, 21.2],
          [1648598400000, 23],
          [1648684800000, 34.8],
          [1648771200000, 38.2],
          [1648857600000, 20.1],
          [1648944000000, 28.2],
          [1649030400000, 30.6],
          [1649116800000, 30.5],
          [1649203200000, 27],
          [1649289600000, 25.8],
          [1649376000000, 22.7],
          [1649462400000, 17.8],
          [1649548800000, 17.8],
          [1649635200000, 17.9],
          [1649721600000, 18],
          [1649808000000, 17.8],
          [1649894400000, 18],
          [1649980800000, 17.9],
          [1650067200000, 18.3],
          [1650153600000, 17.8],
          [1650240000000, 17.7],
          [1650326400000, 17.9],
          [1650412800000, 18.2],
          [1650499200000, 18.1],
          [1650585600000, 18],
          [1650672000000, 17.5],
          [1650758400000, 13.4],
          [1650844800000, 11.5],
          [1650931200000, 9.2],
          [1651017600000, 19.2],
          [1651104000000, 0.542],
          [1651190400000, 0],
          [1651276800000, 0],
          [1651363200000, 0],
          [1651449600000, 0],
          [1651536000000, 16.4],
          [1651622400000, 16.8],
          [1651708800000, 17.1],
          [1651795200000, 17],
          [1651881600000, 17.3],
          [1651968000000, 0.071],
          [1652054400000, 0],
          [1652140800000, 8.44],
          [1652227200000, 1.67],
          [1652313600000, 0],
          [1652400000000, 0],
          [1652486400000, 0],
          [1652572800000, 0],
          [1652659200000, 0],
          [1652745600000, 0],
          [1652832000000, 0],
          [1652918400000, 0],
          [1653004800000, 0],
          [1653091200000, 0],
          [1653177600000, 0],
          [1653264000000, 0],
          [1653350400000, 0],
          [1653436800000, 0],
          [1653523200000, 0],
          [1653609600000, 0],
          [1653696000000, 0],
          [1653782400000, 0],
          [1653868800000, 0],
          [1653955200000, 0],
          [1654041600000, 0],
          [1654128000000, 0],
          [1654214400000, 0],
          [1654300800000, 0],
          [1654387200000, 0],
          [1654473600000, 0],
          [1654560000000, 0],
          [1654646400000, 0],
          [1654732800000, 0],
          [1654819200000, 0],
          [1654905600000, 0],
          [1654992000000, 0],
          [1655078400000, 0],
          [1655164800000, 0],
          [1655251200000, 0],
          [1655337600000, 0],
          [1655424000000, 0],
          [1655510400000, 0],
          [1655596800000, 0],
          [1655683200000, 0],
          [1655769600000, 0],
          [1655856000000, 0],
          [1655942400000, 0],
          [1656028800000, 0],
          [1656115200000, 0],
          [1656201600000, 0],
          [1656288000000, 0],
          [1656374400000, 0],
          [1656460800000, 0],
          [1656547200000, 0],
          [1656633600000, 0],
          [1656720000000, 0],
          [1656806400000, 0],
          [1656892800000, 0],
          [1656979200000, 0],
          [1657065600000, 0],
          [1657152000000, 0],
          [1657238400000, 0],
          [1657324800000, 0],
          [1657411200000, 0],
          [1657497600000, 0],
          [1657584000000, 0],
          [1657670400000, 0],
          [1657756800000, 0],
          [1657843200000, 0],
          [1657929600000, 0],
          [1658016000000, 0],
          [1658102400000, 0],
          [1658188800000, 0],
          [1658275200000, 0],
          [1658361600000, 0],
          [1658448000000, 0],
          [1658534400000, 0],
          [1658620800000, 0],
          [1658707200000, 0],
          [1658793600000, 0],
          [1658880000000, 0],
          [1658966400000, 0],
          [1659052800000, 0],
          [1659139200000, 0],
          [1659225600000, 0],
          [1659312000000, 0],
          [1659398400000, 0],
          [1659484800000, 0],
          [1659571200000, 0],
          [1659657600000, 0],
          [1659744000000, 0],
          [1659830400000, 0],
          [1659916800000, 0],
          [1660003200000, 0],
          [1660089600000, 0],
          [1660176000000, 0],
          [1660262400000, 0],
          [1660348800000, 0],
          [1660435200000, 0],
          [1660521600000, 0],
          [1660608000000, 0],
          [1660694400000, 0],
          [1660780800000, 0],
          [1660867200000, 0],
          [1660953600000, 0],
          [1661040000000, 0],
          [1661126400000, 0],
          [1661212800000, 0],
          [1661299200000, 0],
          [1661385600000, 0],
          [1661472000000, 0],
          [1661558400000, 0],
          [1661644800000, 0],
          [1661731200000, 0],
          [1661817600000, 0],
          [1661904000000, 0],
          [1661990400000, 0],
          [1662076800000, 0],
          [1662163200000, 0],
          [1662249600000, 0],
          [1662336000000, 0],
          [1662422400000, 0],
          [1662508800000, 0],
          [1662595200000, 0],
          [1662681600000, 0],
          [1662768000000, 0],
          [1662854400000, 0],
          [1662940800000, 0],
          [1663027200000, 0],
          [1663113600000, 0],
          [1663200000000, 0],
          [1663286400000, 0],
          [1663372800000, 0],
          [1663459200000, 0],
          [1663545600000, 0],
          [1663632000000, 0],
          [1663718400000, 0],
          [1663804800000, 0],
          [1663891200000, 0],
          [1663977600000, 0],
          [1664064000000, 0],
          [1664150400000, 0],
          [1664236800000, 0],
          [1664323200000, 0],
          [1664409600000, 0],
          [1664496000000, 0],
          [1664582400000, 0],
          [1664668800000, 0],
          [1664755200000, 0],
          [1664841600000, 0],
          [1664928000000, 0],
          [1665014400000, 0],
          [1665100800000, 0],
          [1665187200000, 0],
          [1665273600000, 0],
          [1665360000000, 0],
        ],
      },
      {
        name: 'Other',
        className: 'color-yellow',
        animation: {
          defer: 1,
        },
        data: [
          [1641081600000, 1.09],
          [1641168000000, 2.01],
          [1641254400000, 1.98],
          [1641340800000, 1.8],
          [1641427200000, 3.07],
          [1641513600000, 3.14],
          [1641600000000, 3.21],
          [1641686400000, 1.84],
          [1641772800000, 4.92],
          [1641859200000, 4.73],
          [1641945600000, 2.77],
          [1642032000000, 1.72],
          [1642118400000, 1.9],
          [1642204800000, 1.07],
          [1642291200000, 1.16],
          [1642377600000, 1.63],
          [1642464000000, 2.07],
          [1642550400000, 0.934],
          [1642636800000, 1.53],
          [1642723200000, 2.26],
          [1642809600000, 2.24],
          [1642896000000, 0.184],
          [1642982400000, 1.41],
          [1643068800000, 2.3],
          [1643155200000, 4.08],
          [1643241600000, 2.35],
          [1643328000000, 2.96],
          [1643414400000, 2.14],
          [1643500800000, 1.97],
          [1643587200000, 3.31],
          [1643673600000, 4.57],
          [1643760000000, 5.08],
          [1643846400000, 6.1],
          [1643932800000, 3.6],
          [1644019200000, 2],
          [1644105600000, 1.13],
          [1644192000000, 1.36],
          [1644278400000, 3.4],
          [1644364800000, 4.32],
          [1644451200000, 3.97],
          [1644537600000, 3.76],
          [1644624000000, 2.66],
          [1644710400000, 2.8],
          [1644796800000, 2.08],
          [1644883200000, 3.28],
          [1644969600000, 3.51],
          [1645056000000, 4.25],
          [1645142400000, 2.63],
          [1645228800000, 1.19],
          [1645315200000, 1.66],
          [1645401600000, 3.91],
          [1645488000000, 1.72],
          [1645574400000, 2.51],
          [1645660800000, 3.9],
          [1645747200000, 11.3],
          [1645833600000, 7.96],
          [1645920000000, 9.54],
          [1646006400000, 10.9],
          [1646092800000, 10.8],
          [1646179200000, 11.4],
          [1646265600000, 12.6],
          [1646352000000, 7.16],
          [1646438400000, 13.6],
          [1646524800000, 7.04],
          [1646611200000, 14.3],
          [1646697600000, 8.56],
          [1646784000000, 15],
          [1646870400000, 6.82],
          [1646956800000, 13.7],
          [1647043200000, 6.34],
          [1647129600000, 10.3],
          [1647216000000, 4.58],
          [1647302400000, 11.7],
          [1647388800000, 4.02],
          [1647475200000, 11.4],
          [1647561600000, 4],
          [1647648000000, 8.74],
          [1647734400000, 3.37],
          [1647820800000, 9.14],
          [1647907200000, 3.5],
          [1647993600000, 10.3],
          [1648080000000, 3.7],
          [1648166400000, 10.8],
          [1648252800000, 3],
          [1648339200000, 10.9],
          [1648425600000, 3],
          [1648512000000, 9.68],
          [1648598400000, 3],
          [1648684800000, 8.74],
          [1648771200000, 3],
          [1648857600000, 9.01],
          [1648944000000, 3],
          [1649030400000, 16.7],
          [1649116800000, 3],
          [1649203200000, 9.8],
          [1649289600000, 3],
          [1649376000000, 9.84],
          [1649462400000, 9.87],
          [1649548800000, 10.1],
          [1649635200000, 9.91],
          [1649721600000, 9.95],
          [1649808000000, 9.72],
          [1649894400000, 10],
          [1649980800000, 10.6],
          [1650067200000, 10.9],
          [1650153600000, 11.6],
          [1650240000000, 13],
          [1650326400000, 12.9],
          [1650412800000, 2.89],
          [1650499200000, 3.14],
          [1650585600000, 2.99],
          [1650672000000, 3],
          [1650758400000, 3.01],
          [1650844800000, 2.96],
          [1650931200000, 3.07],
          [1651017600000, 2.97],
          [1651104000000, 2.93],
          [1651190400000, 3.02],
          [1651276800000, 2.91],
          [1651363200000, 2.94],
          [1651449600000, 2.93],
          [1651536000000, 3.05],
          [1651622400000, 2.73],
          [1651708800000, 2.94],
          [1651795200000, 3.14],
          [1651881600000, 2.88],
          [1651968000000, 2.97],
          [1652054400000, 3.04],
          [1652140800000, 2.79],
          [1652227200000, 2.89],
          [1652313600000, 2.99],
          [1652400000000, 3.03],
          [1652486400000, 2.91],
          [1652572800000, 2.95],
          [1652659200000, 3.02],
          [1652745600000, 3],
          [1652832000000, 3],
          [1652918400000, 2.95],
          [1653004800000, 3.36],
          [1653091200000, 2.8],
          [1653177600000, 2.84],
          [1653264000000, 3.02],
          [1653350400000, 2.94],
          [1653436800000, 3],
          [1653523200000, 3.08],
          [1653609600000, 3.01],
          [1653696000000, 3.23],
          [1653782400000, 3.02],
          [1653868800000, 2.7],
          [1653955200000, 3.03],
          [1654041600000, 3],
          [1654128000000, 3.04],
          [1654214400000, 2.99],
          [1654300800000, -1.54],
          [1654387200000, -1.84],
          [1654473600000, -1.83],
          [1654560000000, -1.89],
          [1654646400000, -1.72],
          [1654732800000, -1.71],
          [1654819200000, -1.3],
          [1654905600000, 1.09],
          [1654992000000, 1.09],
          [1655078400000, 1.02],
          [1655164800000, 0.636],
          [1655251200000, 0.772],
          [1655337600000, 0.902],
          [1655424000000, 0.763],
          [1655510400000, 0.658],
          [1655596800000, 1.01],
          [1655683200000, 0.911],
          [1655769600000, 0.987],
          [1655856000000, 0.584],
          [1655942400000, 0.178],
          [1656028800000, 2.97],
          [1656115200000, 3.04],
          [1656201600000, 3.02],
          [1656288000000, 3],
          [1656374400000, 3.01],
          [1656460800000, 2.94],
          [1656547200000, 2.98],
          [1656633600000, 2.98],
          [1656720000000, -0.0054],
          [1656806400000, -0.0187],
          [1656892800000, -0.00926],
          [1656979200000, -0.12],
          [1657065600000, -0.0203],
          [1657152000000, -0.0321],
          [1657238400000, 0.000554],
          [1657324800000, -0.0923],
          [1657411200000, 0.0775],
          [1657497600000, -0.179],
          [1657584000000, -0.284],
          [1657670400000, 0.328],
          [1657756800000, 0.261],
          [1657843200000, -0.019],
          [1657929600000, -0.0432],
          [1658016000000, 0.0278],
          [1658102400000, 0.0369],
          [1658188800000, -0.316],
          [1658275200000, 0.184],
          [1658361600000, 0],
          [1658448000000, 0],
          [1658534400000, 0],
          [1658620800000, 0],
          [1658707200000, 0],
          [1658793600000, 0],
          [1658880000000, 0],
          [1658966400000, 0],
          [1659052800000, 0],
          [1659139200000, 0],
          [1659225600000, 0],
          [1659312000000, 0],
          [1659398400000, 0],
          [1659484800000, 0],
          [1659571200000, 0],
          [1659657600000, 0],
          [1659744000000, 0],
          [1659830400000, 0],
          [1659916800000, 0],
          [1660003200000, 0],
          [1660089600000, 0],
          [1660176000000, 0],
          [1660262400000, 0],
          [1660348800000, 0],
          [1660435200000, 0],
          [1660521600000, 0],
          [1660608000000, 0],
          [1660694400000, 0],
          [1660780800000, 0],
          [1660867200000, 0],
          [1660953600000, 0],
          [1661040000000, 0],
          [1661126400000, 0],
          [1661212800000, 0],
          [1661299200000, 0],
          [1661385600000, 0],
          [1661472000000, 0],
          [1661558400000, 0],
          [1661644800000, 0],
          [1661731200000, 0],
          [1661817600000, 0],
          [1661904000000, 0],
          [1661990400000, 0],
          [1662076800000, 0],
          [1662163200000, 0],
          [1662249600000, 0],
          [1662336000000, 0],
          [1662422400000, 0],
          [1662508800000, 0],
          [1662595200000, 0],
          [1662681600000, 0],
          [1662768000000, 0],
          [1662854400000, 0],
          [1662940800000, 0],
          [1663027200000, 0],
          [1663113600000, 0],
          [1663200000000, 0],
          [1663286400000, 0],
          [1663372800000, 0],
          [1663459200000, 0],
          [1663545600000, 0],
          [1663632000000, 0],
          [1663718400000, 0],
          [1663804800000, 0],
          [1663891200000, 0],
          [1663977600000, 0],
          [1664064000000, 0],
          [1664150400000, 0],
          [1664236800000, 0],
          [1664323200000, 0],
          [1664409600000, 0],
          [1664496000000, 0],
          [1664582400000, 0],
          [1664668800000, 0],
          [1664755200000, 0],
          [1664841600000, 0],
          [1664928000000, 0],
          [1665014400000, 0],
          [1665100800000, 0],
          [1665187200000, 0],
          [1665273600000, 0],
          [1665360000000, 0],
        ],
      },
    ],
  },
];
